import { just, Maybe, nothing } from 'maybeasy';
import { State } from '../Store/Types';
import { array } from 'jsonous';
import { assertNever } from '@kofno/piper';
import ReactionComponent, { RCProps } from '../../../../../../../ReactionComponent';
import DropdownSelectFieldStore from '../Store';
import { FormFieldOutputValue, FieldValue } from '../../../../../Types';
import { getFieldValue } from '../../../../../../../FormFields';
import { formFieldValueDecoder } from '../../../../../Decoders';

interface Props extends RCProps<DropdownSelectFieldStore> {}

const validateValue = (value: FormFieldOutputValue): Maybe<FieldValue[]> =>
  array(formFieldValueDecoder).decodeAny(value).map(just).getOrElse(nothing);

class DropdownSelectReactions extends ReactionComponent<DropdownSelectFieldStore, State, Props> {
  tester = () => this.props.store.state;

  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'initializing':
        state.segmentStore.addEmbeddedFormFieldOutput(store);
        getFieldValue(state.segmentStore.results, store.id)
          .andThen(validateValue)
          .do((value) => store.ready(state.formField, value))
          .elseDo(() => store.ready(state.formField, []));
        break;
      case 'waiting':
      case 'ready':
      case 'auto-saving':
        break;
      default:
        assertNever(state);
    }
  };
}

export default DropdownSelectReactions;
